<template>
  <page-header-wrapper title="客服坐席列表">
    <a-card :bordered="false">
      <a-row :gutter="16" style="margin-bottom: 24px">
        <a-col :span="8">
          <a-statistic title="客服总数" :value="summary.total" />
        </a-col>
        <a-col :span="8">
          <a-statistic title="在线" :value="summary.online" value-style="color: #52c41a" />
        </a-col>
        <a-col :span="8">
          <a-statistic title="离线" :value="summary.offline" value-style="color: rgba(0,0,0,0.45)" />
        </a-col>
      </a-row>

      <div class="table-toolbar">
        <a-button type="primary" :loading="loading" @click="loadList">
          <a-icon type="reload" />刷新
        </a-button>
        <span class="toolbar-tip">在线状态依据工作台心跳，约每 30 秒自动刷新</span>
      </div>

      <a-table
        :loading="loading"
        rowKey="adminId"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="online" slot-scope="text">
          <a-badge :status="text ? 'success' : 'default'" :text="text ? '在线' : '离线'" />
        </span>
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">正常</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="csAgentId" slot-scope="text">
          <a-tooltip v-if="text" :title="text">
            <span>{{ shortId(text) }}</span>
          </a-tooltip>
          <span v-else>—</span>
        </span>
        <span slot="loginDate" slot-scope="text">
          {{ text ? parseTime(text) : '—' }}
        </span>
        <span slot="loginIp" slot-scope="text">
          {{ text || '—' }}
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listCsAgents } from '@/api/customer-service/agents'

export default {
  name: 'CsAgents',
  data() {
    return {
      loading: false,
      list: [],
      refreshTimer: null,
      columns: [
        { title: '在线', dataIndex: 'online', scopedSlots: { customRender: 'online' }, width: 90 },
        { title: '昵称', dataIndex: 'nickName', width: 120, ellipsis: true },
        { title: '登录账号', dataIndex: 'userName', width: 120, ellipsis: true },
        { title: '客服 ID', dataIndex: 'csAgentId', scopedSlots: { customRender: 'csAgentId' }, width: 140 },
        { title: '手机号', dataIndex: 'phoneNumber', width: 130, ellipsis: true },
        { title: '邮箱', dataIndex: 'email', width: 180, ellipsis: true },
        { title: '账号状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '最后登录', dataIndex: 'loginDate', scopedSlots: { customRender: 'loginDate' }, width: 170 },
        { title: '登录 IP', dataIndex: 'loginIp', scopedSlots: { customRender: 'loginIp' }, width: 130, ellipsis: true }
      ]
    }
  },
  computed: {
    summary() {
      const total = this.list.length
      const online = this.list.filter(item => item.online).length
      return {
        total,
        online,
        offline: total - online
      }
    }
  },
  created() {
    this.loadList()
    this.refreshTimer = setInterval(() => {
      this.loadList(true)
    }, 30000)
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    shortId(id) {
      if (!id) return '—'
      const s = String(id)
      return s.length > 16 ? s.substring(0, 8) + '…' + s.substring(s.length - 4) : s
    },
    loadList(silent) {
      if (!silent) {
        this.loading = true
      }
      listCsAgents().then(res => {
        this.list = res.data || []
      }).finally(() => {
        if (!silent) {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.table-toolbar {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.toolbar-tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}
</style>
